<div class="gc-transfer-panel">
  <div class="gc-transfer-panel-header">
    <span>{{ 'genesysTransferPanel.headerText' | translate }}</span>
  </div>

  <app-genesys-transfer-panel-search class="gc-transfer-panel-search"
    (userSelected)="userSelected($event)"
    (queueSelected)="queueSelected($event)">
  </app-genesys-transfer-panel-search>

  <div class="gc-transfer-panel-buttons center">
    <button [disabled]="!selectedUser && !selectedQueue" (click)="onTransfer()" class="btn btn-dark center js-transfer-button">{{ 'genesysTransferPanel.transfer' | translate }}</button>
    <button (click)="cancel.emit()" class="btn btn-light center js-cancel-button">{{ 'genesysTransferPanel.cancel' | translate }}</button>

    <span *ngIf="hasError" class="gc-transfer-panel-error-message js-error-message" [attr.data-automation-id]="'bc-transfer-error-message'">
      {{ 'genesysTransferPanel.transferFailed' | translate }}
    </span>
  </div>
</div>
